import DocsListPage from "@/features/docs/docs-list.page";
import { IncognitoProjectListPage } from "@/features/superuser/incognito/project/incognito-project-list.page";
import { useWorkspaceAccess } from "@/features/workspaces/use-workspace-access";
import { ProjectRoute } from "@/routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/docs/",
)({
  component: DocsListPageRoute,
});

// CR-165: incognito mode gets the display-only list (no create, no delete, no
// members dialog); the member page is untouched.
function DocsListPageRoute() {
  const workspaceAccess = useWorkspaceAccess();
  const { project } = ProjectRoute.useRouteContext();

  if (workspaceAccess.mode === "incognito") {
    return <IncognitoProjectListPage project={project} kind="documents" />;
  }

  return <DocsListPage />;
}
